import { BotProfile, BotSkill } from "./Types";

export class GameConstants {

    public static readonly VERSION = "0.1.0";

    public static readonly DEVELOPMENT = false;
    public static readonly DEVELOPMENT_FREEZE_PLAY = false;
    public static readonly GAME_WIDTH_PORTRAIT = 900;
    public static readonly GAME_HEIGHT_PORTRAIT = 1200;
    public static readonly GAME_WIDTH_LANDSCAPE = 1600;
    public static readonly GAME_HEIGHT_LANDSCAPE = 900;
    public static readonly VALID_DOMAINS: string[] = [];

    public static readonly USES_BYTE_BREW = true;
    public static readonly BYTE_BREW_GAME_ID = "ANp9Bdt9y";
    public static readonly BYTE_BREW_SDK_KEY = "YkBlr0gzaIg1d3IX5088w/cN7L8Q9H42XcNRP/JOMCCeMHYMyCti3bxbshr6KiSX";

    public static readonly BOT_PROFILES: BotProfile[] = [
        { id: 1, name: "James", skill: BotSkill.LOW },
        { id: 2, name: "Manolo", skill: BotSkill.LOW },
        { id: 3, name: "Takeshi", skill: BotSkill.MEDIUM },
        { id: 4, name: "Pablo", skill: BotSkill.MEDIUM },
        { id: 5, name: "George", skill: BotSkill.HIGH },
        { id: 6, name: "Mahmud", skill: BotSkill.HIGH },
        { id: 7, name: "Patrick", skill: BotSkill.MEDIUM },
        { id: 8, name: "Helmut", skill: BotSkill.HIGH },
        { id: 9, name: "Pietro", skill: BotSkill.LOW },
        { id: 10, name: "Krishna", skill: BotSkill.MEDIUM },
        { id: 11, name: "Noam", skill: BotSkill.HIGH },
        { id: 12, name: "Antoine", skill: BotSkill.LOW },
        { id: 13, name: "Elisabeth", skill: BotSkill.MEDIUM },
        { id: 14, name: "Alice", skill: BotSkill.LOW },
        { id: 15, name: "Chloe", skill: BotSkill.LOW },
        { id: 16, name: "Anouk", skill: BotSkill.MEDIUM },
        { id: 17, name: "Saanvi", skill: BotSkill.MEDIUM },
        { id: 18, name: "Rose", skill: BotSkill.HIGH },
        { id: 19, name: "Mia", skill: BotSkill.HIGH },
        { id: 20, name: "Mei", skill: BotSkill.HIGH },
        { id: 21, name: "Aisha", skill: BotSkill.LOW },
        { id: 22, name: "Macarena", skill: BotSkill.MEDIUM },
        { id: 23, name: "Tori", skill: BotSkill.HIGH },
        { id: 24, name: "Janaina", skill: BotSkill.LOW }
    ];
    
    public static readonly SAVED_GAME_DATA_KEY = "bridge-club";
}
